

















  import { CMS } from '@one/types'
  import { Vue, Component, Prop } from 'nuxt-property-decorator'

  @Component
  export default class OneBlogTile extends Vue {
    @Prop() readonly article!: CMS.Responses.ArticleBody
    name: string = 'one-blog-tile'
    showBtn: boolean = false
    mainComponentClass = 'one-blog-tile__article'

    mounted() {
      this.$plugins.onMounted(this.mainComponentClass, this, {
        article: this.article,
      })
    }

    destroyed() {
      this.$plugins.onUnmounted(this.mainComponentClass)
    }

    get blogUrl(): string {
      return this.article.miniatureUrl || `${this.$lib.staticBucket}/pngtree-vector-camera-icon-png-min.jpg`
    }

    toArticle(slug: string) {
      this.$router.push({
        path: `${this.localePath('blog')}/${slug}`,
      })
    }
  }
